import { ChangeDetectorRef, Component, OnDestroy, inject, ChangeDetectionStrategy } from '@angular/core';
import { RoleType } from '@goatsports/core/data-access';
import { ErrorService } from '../services/error.service';
import { LoadingService } from '../services/loading.service';
import { LoadingStatus } from '../models/loading-status';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BaseComponent implements OnDestroy {
  readonly LoadingStatus = LoadingStatus;
  readonly RoleType = RoleType;
  cd = inject(ChangeDetectorRef);
  errorService = inject(ErrorService);
  loadingService = inject(LoadingService);
  isWaiting = false;

  ngOnDestroy() {
    this.errorService.clearServerErrors();
  }
}
